<template>
  <div>
    <hr class="separator-slim mx-6" />
    <div class="search-filter-box p-6">
      <h4 class="fs-20 font-medium mb-4">Price per trip</h4>

      <checkbox v-model="options.min0" v-if="availableBudgetOptions['min0']">
        {{ budgetRange[0] }} ({{ availableBudgetOptions["min0"] || 0 }})
      </checkbox>
      <checkbox
        v-model="options.min1000"
        v-if="availableBudgetOptions['min1000']"
      >
        {{ budgetRange[1000] }} ({{ availableBudgetOptions["min1000"] || 0 }})
      </checkbox>
      <checkbox
        v-model="options.min2000"
        v-if="availableBudgetOptions['min2000']"
      >
        {{ budgetRange[2000] }} ({{ availableBudgetOptions["min2000"] || 0 }})
      </checkbox>
      <checkbox
        v-model="options.min3000"
        v-if="availableBudgetOptions['min3000']"
      >
        {{ budgetRange[3000] }} ({{ availableBudgetOptions["min3000"] || 0 }})
      </checkbox>
      <checkbox
        v-model="options.min4000"
        v-if="availableBudgetOptions['min4000']"
      >
        {{ budgetRange[4000] }} ({{ availableBudgetOptions["min4000"] || 0 }})
      </checkbox>
      <checkbox
        v-model="options.min5000"
        v-if="availableBudgetOptions['min5000']"
      >
        {{ budgetRange[5000] }} ({{ availableBudgetOptions["min5000"] || 0 }})
      </checkbox>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Checkbox from "../../../components/core/Checkbox";
import ClearFiltersMixin from "../../../mixins/ClearFiltersMixin";
import currencyRanges from "../../../helpers/currencyRanges";

export default {
  mixins: [ClearFiltersMixin],
  components: {
    Checkbox,
  },
  data() {
    return {
      options: this.loadOptions(),
    };
  },
  computed: {
    ...mapGetters(["availableBudgetOptions"]),
    ...mapState(["currency"]),
    budgetRange() {
      return currencyRanges[this.currency.code].liveaboard.filterLabel;
    },
  },
  methods: {
    loadOptions() {
      const filters = this.$store.state.filters;
      const budgetValues = filters.budgets.split(",");

      const options = {
        min0: budgetValues.includes("0"),
        min1000: budgetValues.includes("1000"),
        min2000: budgetValues.includes("2000"),
        min3000: budgetValues.includes("3000"),
        min4000: budgetValues.includes("4000"),
        min5000: budgetValues.includes("5000"),
      };

      return options;
    },
  },
  watch: {
    options: {
      deep: true,
      handler(options) {
        let newValue = [];
        if (options.min0) newValue.push("0");
        if (options.min1000) newValue.push("1000");
        if (options.min2000) newValue.push("2000");
        if (options.min3000) newValue.push("3000");
        if (options.min4000) newValue.push("4000");
        if (options.min5000) newValue.push("5000");

        this.$store.commit("setFilter", {
          name: "budgets",
          value: newValue.join(","),
        });
        this.$store.dispatch("loadSuppliers");
      },
    },
  },
};
</script>
